import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProductsApplinksRoute: InvariantJiraRoute = {
	name: 'global-settings-products-applinks',
	path: '/plugins/servlet/applinks/listApplicationLinks',
};
